module.exports = __webpack_public_path__ + "img/login.70ab9958.jpg";